/**
 * Values corresponds to KeyboardEvent.key values
 */
export const KEYBOARD = {
    TAB: 'Tab',
    ESC: 'Escape',
    ENTER: 'Enter',
    ARROW_LEFT: 'ArrowLeft',
    ARROW_UP: 'ArrowUp',
    ARROW_RIGHT: 'ArrowRight',
    ARROW_DOWN: 'ArrowDown',
};
/** Minimum width of the app sidebar, in pixels. */
export const SIDEBAR_MIN_WIDTH = 240;
/** Height of the app top header, in pixels. */
export const TOP_HEADER_HEIGHT = 64;
